import React from "react";
import "../Style/Floatingcontact.css";

const PHONE = "9487812715";

const FloatingContact = () => {
  return (
    <div className="floating-contact">
      <span className="floating-contact__label">Enquire Now</span>

      
     <a   href={`tel:+91${PHONE}`}
        className="floating-contact__btn floating-contact__btn--call"
        aria-label="Call us"
      >
        <i className="ti ti-phone" />
      </a>

      
      <a  href={`https://wa.me/91${PHONE}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-contact__btn floating-contact__btn--whatsapp"
        aria-label="Chat on WhatsApp"
      >
        <i className="ti ti-brand-whatsapp" />
      </a>
    </div>
  );
};

export default FloatingContact;